import {Tile} from '@/components/FilterPlaceholder/components/Tile';
import {FilterStrip} from '@/components/FilterStrip';

export const FilterPlaceholder = () => (
  <FilterStrip>
    <Tile kind="stream" count={1} />
    <Tile kind="stream" count={1} />
    <Tile kind="stream" count={1} />
    <Tile kind="group" count={3} />
    <Tile kind="group" count={3} />
    <Tile kind="group" count={5} />
    <Tile kind="group" count={5} />
  </FilterStrip>
);
